import React from 'react';
import { Container, Grid, Card, CardMedia, Typography } from '@mui/material';
import './_Portfolio.scss';
import img from '../../images/evolve-port-1.jpg';
import img2 from '../../images/evolve-port-2.jpg';

const projects = [
    { id: 1, name: 'Project 1', link: '#', image: img },
    { id: 2, name: 'Project 2', link: '#', image: img2 },
];

const Portfolio = () => (
    <section className="portfolio-section" id="portfolio">
        <Typography variant="h5" className="subtitle">
            Our Work
        </Typography>
        <Container className="portfolio">
            <Grid container spacing={4}>
                {projects.map((project) => (
                    <Grid item xs={12} sm={6} key={project.id}>
                        <Card className="portfolio-item">
                            <a href={project.link}>
                                <CardMedia
                                    component="img"
                                    alt={project.name}
                                    image={project.image}
                                />
                            </a>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container>
    </section>
);

export default Portfolio;
